class NotifiedError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'NotifiedError';
    }
}

export default NotifiedError;
